module.exports = __webpack_public_path__ + "img/mickey150.04800f63.jpg";